import axios from "axios";
import { getHeaders } from "../common/shared";
import { URL } from "../common/constants";

const ReusableCachePagesService = {
  getReusableCachePages: async ({
    search_term = "",
    language_id = null,
    location_id = null,
    approved = true,
    filter_used_count_min = null,
    filter_used_count_max = null,
    filter_created_from = null,
    filter_created_to = null,
    filter_published_from = null,
    filter_published_to = null,
    filter_last_used_from = null,
    filter_last_used_to = null,
    results_per_page = 25,
    page_num = 1,
    order_by = "",
  } = {}) => {
    let response
    try {
      response = await axios({
        method: "post",
        url: `${URL}/v1.0/reusablecachepg`,
        headers: getHeaders().headers,
        data: {
          search_term,
          language_id,
          location_id,
          approved,
          filter_used_count_min,
          filter_used_count_max,
          filter_created_from,
          filter_created_to,
          filter_published_from,
          filter_published_to,
          filter_last_used_from,
          filter_last_used_to,

          results_per_page,
          page_num,
          order_by,
        },

      });

      response.data.data.forEach(pg => {
        delete pg.loc_id;
        delete pg.language_id;
      });
    } catch (error) {
      throw new TypeError(error)
    }
    return response
  },

  updateReusableCachePages: ({ cachepagelist = [] } = {}) => {
    return axios({
      method: "post",
      url: `${URL}/v1.0/reusablecachepg/update/`,
      headers: getHeaders().headers,
      data: { cachepagelist },
    });
  },
};

export default ReusableCachePagesService;
